import { debounce } from "@mongez/reinforcements";
import type { CustomOption } from "core/catalog";
import { useCallback, useMemo } from "react";
import { NumberInput } from "~/design-system/components";
import { CustomOptionLabel } from "./CustomOptionLabel";

type NumberInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: number) => void;
};

export function NumberInputOption({
  customOption,
  onChange,
}: NumberInputOptionProps) {
  const handleChange = useCallback(
    (value: number) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  const debouncedHandleChange = useMemo(
    () => debounce(handleChange, 500),
    [handleChange],
  );

  return (
    <NumberInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      required={customOption.required}
      placeholder={customOption.description}
      defaultValue={customOption.defaultValue as number}
      onChange={debouncedHandleChange}
      classes={{
        wrapper: "w-full",
        label: "w-fit",
      }}
    />
  );
}
